import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadPopup } from '../../Utils/LoginUtils';
import { processSubmitTest } from '../QuizComponent';
import DateTimeDisplay from './DateTimeDisplay';
import { useCountdown } from './useCountdown';

const ExpiredNotice = ({ testId }) => {
    const navigate = useNavigate();
    useEffect(() => {
        loadPopup("Test time is up, auto submitting now");
        processSubmitTest(testId);
        navigate("/");
    })
    return (
        <div className="text-danger">
            <h5>Test Expired!!!</h5>
        </div>
    );
};

export const ShowCounter = ({ days, hours, minutes, seconds }) => {
    const endWarning = (hours === 0 && minutes <= 5);
    return (
        <div className={endWarning ? 'border rounded border-danger' : 'border rounded border-warning'}
            style={{ maxWidth: '10rem', minWidth: '10rem', height: '2.5rem', display: 'flex', justifyContent: 'center', fontWeight: '350' }}>
            {
                days && days > 0 ? <>
                    <DateTimeDisplay value={days} isDanger={false} />
                    <p className='mt-1'>:</p>
                </> : <></>
            }
            <DateTimeDisplay value={hours < 10 ? '0' + hours : hours} isDanger={endWarning} />
            <p className='mt-1'>:</p>
            <DateTimeDisplay value={minutes < 10 ? '0' + minutes : minutes} isDanger={endWarning} />
            <p className='mt-1'>:</p>
            <DateTimeDisplay value={seconds < 10 ? '0' + seconds : seconds} isDanger={endWarning} />
            <p className={endWarning ? 'text-danger ms-1 mt-1' : 'ms-1 mt-1 text-success'}>Left</p>
        </div>
    );
};

const CountdownTimer = ({ targetDate, testId }) => {
    const [days, hours, minutes, seconds] = useCountdown(targetDate);

    if (hours + minutes + seconds <= 0) {
        return <ExpiredNotice testId={testId} />;
    } else {
        return (
            <ShowCounter
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
            />
        );
    }
};

export default CountdownTimer;